export function headerActions() {
    const $body = $("body");
    const $header = $(".header");
    const $mainNav = $(".header-main-nav");
    const $menuDefaultPhoto = $mainNav.find(".header-add-info-holder .photo-holder");
    const $headerMenuOpener = $header.find(".header-menu-opener");
    const $headerMenuOpenerText = $headerMenuOpener.find("span");
    const backMenu = $header.find(".header-main-nav");
    let lastScroll = 0;
    let menuDrop = $mainNav.find(".menu-item-has-children");
    let menuFeaturedLinks = $mainNav.find(".featured-link");
    let defaultPhotoSrc = $menuDefaultPhoto.attr("data-photo");

    menuDrop.each(function () {
        $(this).find(">a").after("<button class='header-mobile-menu-opener'><svg width=\"17\" height=\"17\" viewBox=\"0 0 17 17\">\n" +
            "<path d=\"M3.5 0.25V1.875H13.7294L0.25 15.3544L1.39562 16.5L14.875 3.02062V13.25H16.5V0.25H3.5Z\" fill=\"white\"/>\n" +
            "</svg></button>");
    });

    $header.find(".header-main-logo").after("<ul class='header-main-nav-featured'></ul>");

    menuFeaturedLinks.each(function (i, it) {
        let clone = $(it).clone();
        $(".header-main-nav-featured").append(clone);
    });

    $headerMenuOpener.on("click", function () {
        if ($body.hasClass("menu-open")) {
            menuDrop.removeClass("active");
            $body.removeClass("menu-open");
            $headerMenuOpenerText.addClass("hide");
            setTimeout(function () {
                $headerMenuOpenerText.removeClass("hide").text("menu");
            }, 500);
        } else {
            $body.addClass("menu-open");
            $headerMenuOpenerText.addClass("hide");
            setTimeout(function () {
                $headerMenuOpenerText.removeClass("hide").text("close");
            }, 500);
        }
    });
    $body.on("click", ".header-mobile-menu-opener", function () {
        let $parent = $(this).parent();
        if ($parent.hasClass("active")) {
            $parent.removeClass("active");
        } else {
            $(".menu-item-has-children").removeClass("active");
            $parent.addClass("active");
        }
    });
    backMenu.on("click", function () {
        $(".menu-item-has-children").removeClass("active");
    });
    $body.on("mouseover", ".innovations-holder a", function () {
        let $this = $(this);
        if ($this.parents(".featured-link")) {
            let photoSrc = $this.attr("data-image");
            let $photoHolder = $this.parents().find(".photo-banner");
            $photoHolder.removeClass("show");
            setTimeout(function () {
                $photoHolder.addClass("show").css({
                    "background-image": "url('" + photoSrc + "')"
                });
                if ($this.parents(".products-links").length) {
                    $menuDefaultPhoto.addClass("product-image");
                }
            }, 300);
        }
    });
    $body.on("mouseout", ".innovations-holder a", function () {
        let $this = $(this);
        if ($this.parents(".featured-link")) {
            let $photoHolder = $this.parents().find(".photo-banner");
            $photoHolder.removeClass("show product-image");
        }
    });

    $mainNav.on("mouseover", "a", function () {
        let $this = $(this);
        let photoSrc = $this.attr("data-image");
        if (photoSrc) {
            $menuDefaultPhoto.addClass("hide");
            setTimeout(function () {
                $menuDefaultPhoto.removeClass("hide default-image").css({
                    "background-image": "url('" + photoSrc + "')"
                });
                if ($this.parents(".products-links").length) {
                    $menuDefaultPhoto.addClass("product-image");
                }
            }, 300);
        }
        if (!photoSrc && !$menuDefaultPhoto.hasClass("default-image")) {
            $menuDefaultPhoto.addClass("hide default-image");

            setTimeout(function () {
                $menuDefaultPhoto.removeClass("hide").css({
                    "background-image": "url('" + defaultPhotoSrc + "')"
                });
                $menuDefaultPhoto.removeClass("product-image");
            }, 300);
        }
    });

    $mainNav.on("mouseout", " a", function () {
        if (!$menuDefaultPhoto.hasClass("default-image")) {
            $menuDefaultPhoto.addClass("hide default-image");
            setTimeout(function () {
                $menuDefaultPhoto.removeClass("hide").css({
                    "background-image": "url('" + defaultPhotoSrc + "')"
                });
                $menuDefaultPhoto.removeClass("product-image");
            }, 300);
        }
    });

    function stickyHeader() {
        let currentScroll = window.pageYOffset;
        if (currentScroll === 0) {
            $body.removeClass("up");
            $header.removeClass("sticky");
            return;
        }
        if (currentScroll > 0) {
            $header.addClass("sticky");
        } else {
            $header.removeClass("sticky");
        }
        if (currentScroll > lastScroll + 10 && !$body.hasClass("down")) {
            $body.removeClass("up").addClass("down");
        } else if (currentScroll < lastScroll && $body.hasClass("down")) {
            $body.removeClass("down").addClass("up");
        }
        lastScroll = currentScroll;
    }


    window.addEventListener("load", () => {
        stickyHeader();
    });
    window.addEventListener("scroll", () => {
        stickyHeader();
    });
    $header.addClass("show");
}


// WEBPACK FOOTER //
// ./assets/js/modules/headerActions.js